import { createVanIconComponent } from "./van"

const BullhornOutlined = createVanIconComponent("bullhorn-o")
export default BullhornOutlined
